module.exports = __webpack_public_path__ + "static/img/404.ba8e75f9.png";